import { fromPromise } from 'rxjs/internal/observable/innerFrom';
import localForage from 'localforage';
import { map } from 'rxjs';

export const verifyPermissionForRolesUtil = (...labels: string[]) => {
  return fromPromise(localForage.getItem<string[]>('role')).pipe(
    map((roles) => {
      if (Array.isArray(roles)) {
        const rolesSet = new Set(roles);
        return labels.some((label) => rolesSet.has(label));
      } else {
        return false;
      }
    })
  );
};
